import axios, { AxiosInstance, AxiosError } from "axios";
import logger, { LoggingSource } from "@/shared/Logger";
type IpInfo = {
  device: string;
  ip: string;
  hostname: string;
  city: string;
  region: string;
  country: string;
  loc: string;
  org: string;
  postal: string;
  timezone: string;
};
export default class SecurityApi {
  private readonly _axiosInstance: AxiosInstance;
  private readonly URL = "https://ipinfo.io/json";

  constructor() {
    this._axiosInstance = axios.create({
      baseURL: this.URL,
    });
  }

  async getIpInfo() {
    let result: IpInfo = {
      device: "",
      ip: "",
      hostname: "",
      city: "",
      region: "",
      country: "",
      loc: "",
      org: "",
      postal: "",
      timezone: "",
    };
    try {
      logger.info("getIPInfo...", LoggingSource.IPInfo);

      try {
        logger.timeStart("getIPInfo call", LoggingSource.IPInfo);
        const response = await this._axiosInstance.get<IpInfo>(this.URL);
        logger.timeEnd("getIPInfo call", LoggingSource.IPInfo);
        if (response != null) {
          result = response.data;
          logger.debug(
            `getIPInfo: ${JSON.stringify(response.data)}`,
            LoggingSource.IPInfo
          );
        }
      } catch (ex) {
        // getting an error here should not stop the login process
        // so we just log the error
        if (axios.isAxiosError(ex)) {
          const { error } = ex.response?.data || {
            error: { title: ex.code, message: ex.message },
          };
          logger.error(
            `IpInfo ${error.title}: ${error.message}`,
            LoggingSource.IPInfo
          );
        }
        logger.timeEnd("getIPInfo call", LoggingSource.IPInfo);
      }

      return result;
    } catch (error) {
      logger.timeEnd("getIPInfo call", LoggingSource.IPInfo);
      logger.error(JSON.stringify(error), LoggingSource.IPInfo);
      throw error;
    } finally {
      logger.info("...getIPInfo", LoggingSource.IPInfo);
    }
  }
}
